// see - https://www.figma.com/design/9D4Ao5j9kbxunNKph0WR96/Config-Viewer---AntBlocks-1.7?node-id=21390-61578&t=jm0IZJkJGYw6Zwnj-4
import type { AnchorHTMLAttributes, PropsWithChildren } from 'react';
import React from 'react';
import { ButtonVariant, type IButtonProps } from './button-style-helper';
import { Button } from './Button';

/** Only use this for links to external sites! Otherwise use LinkButton.tsx */
export const AnchorButton: React.FC<
PropsWithChildren<
Omit<IButtonProps, 'type' | 'variant'> &
Partial<Pick<IButtonProps, 'type' | 'variant'>> &
Omit<AnchorHTMLAttributes<unknown>, 'style' | 'aria-disabled' | 'href'> &
Required<Pick<AnchorHTMLAttributes<unknown>, 'href'>>
>
> = ({
  href,
  target = '_blank',
  type = 'button',
  variant = ButtonVariant.FLAT,
  ...props
}) => (
  <Button
    href={href}
    target={target}
    type={type}
    variant={variant}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
);
